import React, { useMemo } from 'react';
import SliderLib from '@ant-design/react-slick';
import { getChildren } from '../../utils/bundle.esm2.js';
import useWindowSize from '../../hooks/bundle.esm3.js';
import { getSelectedDimension, getSettings } from './bundle.esm2.js';
import SliderStyled from './bundle.esm3.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Slider = (props) => {
  const { className, width, children, height, responsive = [], gap } = props;
  const { slideWidth, animated, infinite, arrows } = props;
  const { prevArrow, nextArrow } = props;
  const { width: windowWidth } = useWindowSize();
  const defaultDimensions = useMemo(
    () => ({ height, width: width != null ? width : windowWidth, slideWidth, gap }),
    [width, height, slideWidth, windowWidth, gap]
  );
  const responsiveCandidate = getSelectedDimension(responsive, windowWidth);
  const selectedConfig = responsiveCandidate != null ? responsiveCandidate : defaultDimensions;
  const { width: selectedWidth, height: selectedHeight } = selectedConfig;
  const actualChildren = getChildren(children);
  const settingOverrides = {
    autoplay: !!animated,
    autoplaySpeed: animated,
    infinite: !!infinite,
    arrows: !!arrows,
    prevArrow,
    nextArrow
  };
  const settings = getSettings(settingOverrides);
  return /* @__PURE__ */ React.createElement(SliderStyled, {
    className: `Slider ${className}`,
    slideWidth,
    width: selectedWidth != null ? selectedWidth : windowWidth,
    height: selectedHeight,
    gap,
    slidesCount: actualChildren.length
  }, /* @__PURE__ */ React.createElement(SliderLib, __spreadValues({}, settings), actualChildren.map((slide, index) => {
    return /* @__PURE__ */ React.createElement("div", {
      className: "Slider__slide",
      key: index
    }, slide);
  })));
};
Slider.defaultProps = {
  className: "",
  arrows: false,
  responsive: []
};

export { Slider as default };
//# sourceMappingURL=bundle.esm.js.map
